<template>
<div>
  <aside class="main-content">
    <div class="content">
      <div class="nest-contents">
        <h2>入力されたメールアドレス宛てにメールを送信しました</h2>
        <p>メールをご確認のうえ、{{ type }}を完了してください。</p>
      </div>
    </div>
  </aside>
</div>
</template>

<script>
export default {
  data() {
    return {
      type: this.$parent.title
    }
  }
}
</script>